"use client";
import * as yup from "yup";
import {Form, FormField, FormMessage} from "@/components/ui/form";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import useAxiosAuth from "@/lib/hooks/useAxiosAuth";
import {useRouter} from "next/navigation";
import {useState} from "react";
import CWFResponsiveDialog from "@/components/ui/CWFResponsiveDialog";
import CWFTextarea from "@/components/ui/CWFTextarea";
import CWFButton from "@/components/ui/CWFButton";
import toast from "react-hot-toast";


const REQUIRED_ERROR = "Ce champs est requis";
const commentSchema = yup.object({
    comment : yup.string().required(REQUIRED_ERROR)
})

export default function CommentUpdateForm({idComment, openComment, setOpenComment, comment}){
    const axios = useAxiosAuth();
    const router = useRouter();
    const [loading, setLoading] = useState(false);

    const commentForm = useForm({
        resolver : yupResolver(commentSchema),
        defaultValues : {
            comment : comment
        }
    });

    function updateComment(data){
        axios.put(`comments/${idComment}`, data)
            .then(() => toast.success('Commentaire mis à jour'))
            .catch(() => toast.error("Une erreur est sruvenue"))
            .finally(() => {
                setOpenComment(false);
                router.refresh()
            });
    }

    return(
        <CWFResponsiveDialog
            title={<p>Mis à jour du commentaire</p>}
            open={openComment}
            onOpenChange={setOpenComment}
            trigger={null}
        >
            <Form {...commentForm}>
                <form className={"grid gap-2"} onSubmit={commentForm.handleSubmit(updateComment)}>
                    <CWFTextarea name={"comment"} control={commentForm.control} label={"Commentaire"}/>
                    <div className={"flex justify-end"}>
                        <CWFButton loading={loading}>Mettre à jour</CWFButton>
                    </div>
                </form>
            </Form>
        </CWFResponsiveDialog>
    )
}